function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconListView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "#333",
    fill: "none"
  },
  transform: "translate(1 .5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none",
  rx: 0.5,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h1v1h-1z",
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "sp_header_area_line",
  style: {
    stroke: "#333",
    fill: "none"
  },
  transform: "translate(1 6.5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none",
  rx: 0.5,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h1v1h-1z",
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "sp_header_area_line",
  style: {
    stroke: "#333",
    fill: "none"
  },
  transform: "translate(1 12.5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  stroke: "none",
  rx: 0.5,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h1v1h-1z",
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h10.5v1H0z",
  "data-name": "sp_header_area_line",
  style: {
    fill: "#333"
  },
  transform: "translate(5.5 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h10.5v1H0z",
  "data-name": "sp_header_area_line",
  style: {
    fill: "#333"
  },
  transform: "translate(5.5 7)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h10.5v1H0z",
  "data-name": "sp_header_area_line",
  style: {
    fill: "#333"
  },
  transform: "translate(5.5 13)"
}));
export default SvgIconListView;